<mat-card class="event-card" [style.background-image]="imageLink(event.featuredImageId)">
    <img mat-card-image class="featured-image" src="{{transparentSource}}" alt="form">
    <mat-card-content class="content">
        <mat-card-title>{{event.title}}</mat-card-title>
        <mat-card-subtitle class="location-wrapper"><mat-icon class="loc-icon">location_on</mat-icon> <div><a href="{{getMapLink(event.location)}}">{{event.location}}</a></div></mat-card-subtitle>
        <div class="button-wrapper">
            <button type="button" mat-raised-button color="accent" class="seemore" (click)="goToEvent(event.id)">{{'SHARED.Button.More' | translate }}</button>
        </div>
    </mat-card-content>
  </mat-card>